// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2LcAe","col":"styles_col__1_Izj"};